// GFM styled to the Maud chat theme (14px body, neutral tokens) so rendered
// markdown reads as chat content rather than raw browser defaults.
export const MAI_CHAT_MARKDOWN_STYLES = {
  '& > :first-of-type': { marginTop: 0 },
  '& > :last-child': { marginBottom: 0 },
  '& p': { margin: '0 0 8px' },
  '& h1, & h2, & h3, & h4, & h5, & h6': {
    fontWeight: 600,
    lineHeight: 1.3,
    color: 'neutral.primary',
    margin: '14px 0 6px',
  },
  '& h1': { fontSize: '16px' },
  '& h2': { fontSize: '15px' },
  '& h3, & h4, & h5, & h6': { fontSize: '14px' },
  '& ul, & ol': { margin: '0 0 8px', paddingLeft: '20px' },
  '& li': { margin: '2px 0' },
  '& li > ul, & li > ol': { margin: '2px 0' },
  '& a': { color: 'primary.100', textDecoration: 'underline' },
  '& strong': { fontWeight: 600, color: 'neutral.primary' },
  '& hr': {
    border: 'none',
    borderTop: '1px solid',
    borderColor: 'neutral.line',
    margin: '12px 0',
  },
  '& blockquote': {
    margin: '0 0 8px',
    paddingLeft: '12px',
    borderLeft: '3px solid',
    borderColor: 'neutral.line',
    color: 'neutral.secondary',
  },
  '& table': {
    width: '100%',
    borderCollapse: 'collapse',
    margin: '0 0 8px',
    fontSize: '13px',
  },
  '& th, & td': {
    border: '1px solid',
    borderColor: 'neutral.line',
    padding: '6px 8px',
    textAlign: 'left',
    verticalAlign: 'top',
  },
  '& th': {
    background: 'neutral.background.secondary',
    fontWeight: 600,
    color: 'neutral.primary',
  },
  '& code': {
    fontFamily: 'monospace',
    fontSize: '13px',
    background: 'neutral.background.secondary',
    padding: '1px 4px',
    borderRadius: '4px',
  },
  '& pre': {
    margin: '0 0 8px',
    padding: '10px 12px',
    borderRadius: '8px',
    background: 'neutral.background.secondary',
    overflowX: 'auto',
  },
  '& pre code': { background: 'transparent', padding: 0 },
};
